import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux';
import { getTermFromState } from '../../../../../../redux/selectors/i18n'
import AppModal from '../../../../../../components/Modal';

/**
 * OfferModal displays on Offers wherethe Special Priving details link
 * shows to detail the offers details and terms/conditions
 */
class OfferModal extends Component {

  static propTypes = {
    modalOpen: PropTypes.bool.isRequired,
    offerApplied: PropTypes.bool.isRequired,
    paymentType: PropTypes.string.isRequired,
    optionType: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    fullOfferDescription: PropTypes.string.isRequired,
    monthlyPayment: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    detailsI18N: PropTypes.object.isRequired,
  };

  static defaultProps = {
    modalOpen: false,
    offerApplied: true
  };

  // Renders the internal content of the modal
  renderInstructions() {
    const {
      offerApplied,
      monthlyPayment,
      detailsI18N,
      paymentType,
      optionType,
    } = this.props;
    const msg = offerApplied ?
        `${detailsI18N.btnRemove} <strong>${monthlyPayment}${detailsI18N.month} ${paymentType} ${optionType}</strong> ${detailsI18N.btnContent2}`
        : `${detailsI18N.btnAdd} <strong>${monthlyPayment}${detailsI18N.month} ${paymentType} ${optionType}</strong> ${detailsI18N.btnContent2}`;
    return (<p dangerouslySetInnerHTML={{ __html: msg }} />)
  }

  // Renders the Close button for the modal
  renderButtonGroup() {
    const {
        onClose,
        detailsI18N,
    } = this.props;
    return (
      <div className="expanded button-group">
        <a className="button primary expanded" onClick={onClose} >{detailsI18N.close}</a>
      </div>
    )
  }

  render() {
    const {
        modalOpen,
        onClose,
        title,
        fullOfferDescription
    } = this.props;

    return (
      <AppModal modalStyles={{ maxWidth: '1000px' }} isModalOpen={modalOpen} onClose={onClose}>
        <h2 className="heading-second">{title}</h2>
        <p dangerouslySetInnerHTML={{ __html: fullOfferDescription }} />
        {this.renderButtonGroup()}
      </AppModal>
    );
  }
}

const mapStateToProps = state => ({
  detailsI18N: getTermFromState(state, 'offerPanel.detailsModal'),
});

export default connect(mapStateToProps)(OfferModal);




/** WEBPACK FOOTER **
 ** ./src/pages/TrimView/BestOfferList/BestOfferCard/components/OfferModal/index.js
 **/